import React from "react";
import { Container, Typography, Paper, Box, Button } from "@mui/material";
import VideoEmbed from './VideoEmbed';

const Coaching = ({ gotocoaching }) => {
  return (
    <Container maxWidth="md" sx={{ mt: 6 }}>
	<Button color="inherit" onClick={gotocoaching} sx={{ mr: 1 }}>
			Coaching Home
	</Button>
	<br/>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h4" align="center" gutterBottom>
          Coaching
        </Typography>

        <Box
          sx={{
            mt: 3,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            overflow: "hidden",
            borderRadius: 2,
            boxShadow: 2,
          }}
        >
	  <video
	    controls
	    className="w-full max-h-[500px] mb-6 rounded-lg shadow"
	  >
	    <source src="/videos/Coaching.mp4" type="video/mp4" />
	    Your browser does not support the video tag.
	  </video>

        </Box>
      </Paper>
    </Container>
  );
};

export default Coaching;
